import { useEffect, useRef } from 'react';
import { IPCRendererCallback, shell } from './adapter';

let lastRan: Date | undefined = undefined;
const throttle = 2000;

export const useShell = () => {
  const versionRef = useRef<string | undefined>(undefined);

  /* version check */
  useEffect(() => {
    if (!shell.isShell || (lastRan && lastRan.valueOf() > Date.now() - throttle)) return;

    lastRan = new Date();
    const id = `info:version:${Math.random()}`;

    shell.emit?.('info:version', undefined);

    const handler: IPCRendererCallback<'info:version'> = (_e, version) => {
      if (version && version !== versionRef.current) {
        shell.version = version;
        versionRef.current = version;
      }
    };

    shell.on?.('info:version', handler, id);
    return () => {
      shell.off?.('info:version', handler, id);
    };
  }, []);

  return shell;
};
